import Captcha from './recaptcha';
import Form from './form';
import Header from './header';
import Map from './map';
import Share from './share';
import Slider from './slider';
import Timetable from './timetable';

export default () => {
    Captcha.init();
    Form.init();
    Header.init();
    Map.init();
    Share.init();
    Slider.init();
    Timetable.init();
};
